import React from 'react';
import styled from 'styled-components';
import { useTextViewStore } from '../../../shared/store/TextViewStore';
import { useTextBlockImageDrop } from '../../../shared/hooks/useTextBlockImageDrop';
import TextImageDropLayer from '../TextImageDropLayer';

export interface TextViewerShellProps {
  children: React.ReactNode;
}

/** Texts 중간 본문 컬럼(TextViewer / MultiTextViewer / IndexTextViewer) 래퍼 */
const TextViewerShell: React.FC<TextViewerShellProps> = ({ children }) => {
  const isLargeBody = useTextViewStore((s) => s.isLargeBody);
  const toggleIsLargeBody = useTextViewStore((s) => s.toggleIsLargeBody);
  const {
    isImageDragActive,
    remainingImageCount,
    onDragEnter,
    onDragOver,
    onDragLeave,
    onDrop,
  } = useTextBlockImageDrop();

  return (
    <Outer
      $isExtended={isLargeBody}
      onDragEnter={onDragEnter}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    >
      <ToggleButton onClick={toggleIsLargeBody}>
        {isLargeBody ? '<  >' : '<>'}
      </ToggleButton>
      <Shell>{children}</Shell>
      <TextImageDropLayer
        isVisible={isImageDragActive}
        remainingCount={remainingImageCount}
      />
    </Outer>
  );
};

const Outer = styled.div<{ $isExtended: boolean }>`
  position: relative;
  width: ${({ $isExtended }) => ($isExtended ? 'calc(38vw * 1.2)' : '38vw')};
  max-width: ${({ $isExtended }) => ($isExtended ? '720px' : '600px')};
  height: 100%;
  flex-shrink: 0;
  --text-viewer-w: ${({ $isExtended }) => ($isExtended ? 'calc(38vw * 1.2)' : '38vw')};
  --text-viewer-max: ${({ $isExtended }) => ($isExtended ? '720px' : '600px')};
  transition: width 0.3s ease, max-width 0.3s ease;
`;

const ToggleButton = styled.div`
  position: absolute;
  left: 100%;
  top: calc(13vh);
  height: 28px;
  display: flex;
  align-items: center;
  padding-left: 8px;
  white-space: nowrap;
  z-index: 2;
  ${({ theme }) => theme.typography.Footer_01};
  color: ${({ theme }) => theme.colors.color_Gray_05};
  cursor: pointer;
`;

const Shell = styled.section`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  padding-top: calc(13vh);
  padding-bottom: 40px;
`;

export default TextViewerShell;
